export enum ActualTripSelectorField {
  fromLocation = 'fromLocation',
  fromDateTime = 'fromDateTime',
  toLocation = 'toLocation',
  toDateTime = 'toDateTime',
  comments = 'comments',
}
